import { createSelector } from 'reselect';
import { getCurrentUser } from '../user/user.selectors';
import orderBy from 'lodash/orderBy';

const allIds = (state) => state.entities.transaction.allIds;
const byId = (state) => state.entities.transaction.byId;

const productsById = (state) => state.entities.product.byId;
const productCategoriesById = (state) => state.entities.productCategory.byId;

export const getAllTransactions = createSelector(
  [ byId, allIds, productsById, productCategoriesById ],
  (transactions, ids, products, productCategories) => {
    const mappedTransactions = ids.map(id => {
      const transaction = transactions[id];
      const product = products[transaction.product];
      const productCategory = productCategories[product.productCategory];
      return {
        ...transaction,
        product: {
          ...product,
          productCategory,
        }
      };
    });
    return orderBy(mappedTransactions, 'createdAt', 'desc');
  }
);

export const getTransactionsForUser = createSelector(
  [ getAllTransactions, (state, userId) => userId ],
  (transactions, userId) => {
    const filtered = transactions.filter(transaction => transaction.user._id === userId);
    return orderBy(filtered, 'createdAt', 'desc');
  }
);

export const getTransactionsForCurrentUser = createSelector(
  [ getAllTransactions, getCurrentUser ],
  (transactions, currentUser) => {
    const filtered = transactions.filter(transaction => transaction.user._id === currentUser._id);
    return orderBy(filtered, 'createdAt', 'desc');
  }
);

export const getTransactionsForCurrentUserChannel = createSelector(
  [ getAllTransactions, getCurrentUser ],
  (transactions, currentUser) => {
    const filtered = transactions.filter(transaction => transaction.user.channel._id === currentUser.channel._id);
    return orderBy(filtered, 'createdAt', 'desc');
  }
);

export const getTransactionsForCurrentUserTeam = createSelector(
  [ getAllTransactions, getCurrentUser ],
  (transactions, currentUser) => {
    const filtered = transactions.filter(transaction => transaction.user.team === currentUser.team._id);
    return orderBy(filtered, 'createdAt', 'desc');
  }
);


// WEBPACK FOOTER //
// ./src/modules/transaction/transaction.selectors.js